import React from 'react'
import ContainerDashboard from '../components/layouts/ContainerDashboard'
import { Link } from 'react-router-dom'
import config from './Config'
import "./NotFound.css"

const PageNotFound = () => {


    return (
        <>
            <ContainerDashboard title="404 Not Found" description="Page Not Found">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">

                        <div className="col-md-12 ">

                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>
                                <section className="page_404">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 ">
                                                <div className=" text-center">
                                                    <div className="four_zero_four_bg">
                                                        <h1 className="text-center ">404</h1>

                                                    </div>

                                                    <div className="contant_box_404">
                                                        <h3 className="h2">
                                                            Look like you're lost
                                                        </h3>

                                                        <p>the page you are looking for not avaible!</p>

                                                        <Link to={config.appUrl} className="link_404">Go to Dashboard</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>

                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default PageNotFound